module.exports = new __parcel__URL__("87703_sq.0cae0204.jpg").toString();